<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>短信</li>
                <li><a href="#">短信收件箱/短信上行</a></li>
            </ul>
        </div>
    
    <div class="rightinfo">
    
    
    <ul class="seachform mt20">
    
    <li><label>手机号</label><input name="" v-model="mobile" type="text" class="scinput" /></li>
    
    <li><label>月份</label>
        <div class="cityleft">
            <el-date-picker
                v-model="month"
                type="month"
                placeholder="选择月份"
                format="MM"
                value-format="MM">
            </el-date-picker>
        </div>
    </li>
    
    <li><label>内容</label><input name="" v-model="content" type="text" class="scinput" style="width:300px;"/></li>
    
    <li><label>&nbsp;</label><input name="" type="button" class="scbtn" @click="pageChange(1)" value="查询"/></li>
    
    </ul>
    
    <div class="tools lh33">
        <b><!--"二办信使" 短信到达通知振铃号码调整为：057156896999--> 点击手机号可查看沟通记录</b>
        <el-button type="danger" class="top_button" style="letter-spacing: 2px;float:right;" @click="deletechoose()">批量删除</el-button>
    </div>
    
    
    <table class="tablelist">
    	<thead>
    	<tr>
            <th><input type="checkbox" name="all" id="all" @click="selectall()"/></th>
            <th style="width:15%">电话号码</th>
            <th style="width:60%">短信内容</th>
            <th style="width:15%">时间</th>
            <th style="width:10%">操作</th>
        </tr>
        </thead>
        <tbody>
        
        <tr v-for="(item,index) in smsMoLogList"  :class="{odd:index%2!=0}">
            <td style="width:3%">
                <input type="checkbox" class="pr5" name="ids" id="ids" v-bind:value="item.id"/>
            </td>
            <td style="width:12%"><a href="#" @click="gotosmshistory(item.mobile)">{{item.mobile}}</a></td>
            <td style="width:60%;">{{item.content}}</td>
            <td style="width:15%">{{item.createtime}}</td>
            <td style="width:10%"><a href="#" class="tablelink" @click="delSmsMo(item.id)">删除</a> <a href="#" @click="gosmssend(item.mobile,item.content)" class="tablelink">回复</a></td>
        </tr>
        </tbody>
    </table>
    
    <div class="pagin">
        <el-button type="danger" class="top_button" style="letter-spacing: 2px;float:right;" @click="deletechoose()">批量删除</el-button>
    	<el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[50]"
            :page-size="50"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
        </el-pagination>
    </div>
   
   <div class="jian">&nbsp;</div>
     <div class="welinfo">
    <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
    <b>自主回复</b>
    </div>
    
    <ul class="infolist">
    <li><span>固定短信接收号批量收短信,方便快捷便宜（暂时免费），适合报名、数据采集、统计报表。支持API接口获取数据</span></li> 
    <li><span>使用方法： 发 "门牌号#内容 " 到 1373 8090 222 或 (021 5212 9052(暂停)) </span></li>
    <li><span>注意门牌号后面要跟#, 如手机号A发送短信"20582#老钱我报名" ，则门牌号20582会收到 A号码"老钱我报名"</span></li>
    </ul>
    </div> 
    
    
    <div class="tip">
    	<div class="tiptop"><span>提示信息</span><a></a></div>
        
      <div class="tipinfo">
        <span><img src="../../assets/images/ticon.png" /></span>
        <div class="tipright">
        <p>是否确认对信息的修改 ？</p>
        <cite>如果是请点击确定按钮 ，否则请点取消。</cite>
        </div>
        </div>
        
        <div class="tipbtn">
        <input name="" type="button"  class="sure" value="确定" />&nbsp;
        <input name="" type="button"  class="cancel" value="取消" />
        </div>
    
    </div>
    
    <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
        top: 0; left: 0;display: block;" v-show="loadingShow"></div>
    <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
        -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
        <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
        <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
    </div>
    
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            mobile:'',
            month: '',
            content:'',
            pageIndex:0,
            totalCount:0,
            smsMoLogList:[],
            loadingShow: true,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':50,'mobile':this.mobile,'month':this.month,'content':this.content};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/smsmolog.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.smsMoLogList = res.data.smsMoLogList;
                    that.pageIndex = parseInt(pageIndex);
                    // that.pageCount = res.data.page.pageCount;
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        gosmssend(mobile,content){
            
            this.$router.push({
                path: '/smssend',   
                query: {
                    mobile: mobile,
                    content: content
                }
            })

        },
        delSmsMo(id){
            let that = this;
            let data = {'ids':id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/delsmsmolog.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$message({
                        type: 'success',
                        message: "删除上行短信成功!"
                    });
                    that.cleanchoose();
                    that.pageChange(1);
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        gotosmshistory(mobile){
            location.href = "/smshistory?mobile=" +mobile
        },
        selectall() {
            var checkers = document.getElementsByName('ids')
            if (document.getElementById("all").checked == true)
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = true;
                }
            }
            else
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = false;
                }
            }
        },
        choose() {
            var said = ""
            var ids = document.getElementsByName("ids")
            for(var i=0; i<ids.length; i++){
                if( ids[i].checked == true )
                {
                    if( said == "" )
                    {
                        said = ids[i].value
                    }
                    else
                    {
                        said = said + "//" + ids[i].value
                    }
                }
            }
            return said
        },
        cleanchoose() {
            document.getElementById("all").checked = false
            var checkers = document.getElementsByName('ids')
            for ( var i = 0; i < checkers.length; i++)
            {
                checkers[i].checked = false
            }
        },
        //批量删除
        deletechoose() {
            var that = this
            if(this.choose() == "")
            {
                this.$alert("请选择删除项!")
                return false;
            }
            var that = this;
            let param = {'ids': this.choose()};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/sms/delsmsmolog.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$message({
                        type: 'success',
                        message: "批量删除上行短信成功!"
                    });
                    that.cleanchoose();
                    that.pageChange(1);
                }
                else
                {
                    that.$message({
                        type: 'error',
                        message: res.data.msg
                    });
                    return false;
                }
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smsmo.vue